import { performFullNewCustomerReset } from '@/lib/performFullNewCustomerReset';
import React, { useEffect, useRef } from 'react';
import { Navigate, useLocation, useRoutes } from 'react-router-dom';
import AgeSmoker from '@/pages/AgeSmoker';
import Home from '@/pages/Home';
import Otp from '@/pages/Otp';
import Pdpa from '@/pages/Pdpa';
import DevReg from '@/pages/DevReg';
import NpdAwareness from '@/pages/NpdAwareness';
import NpdCorrect from '@/pages/NpdCorrect';
import NpdWrong from '@/pages/NpdWrong';
import SmokerProfile from '@/pages/SmokerProfile';
import Switch from '@/pages/Switch';
import SwitchReason from '@/pages/SwitchReason';
import Tng from '@/pages/Tng';
import TradeIn from '@/pages/TradeIn';
import TradeInContact from '@/pages/TradeInContact';
import UniqueCode from '@/pages/UniqueCode';
import ThankYou from '@/pages/ThankYou';

function ResetClientWhenLeavingTng() {
  const { pathname } = useLocation();
  const prevPath = useRef(pathname);
  useEffect(() => {
    const wasTng = prevPath.current === '/tng';
    const nowTng = pathname === '/tng';
    if (wasTng && !nowTng) {
      performFullNewCustomerReset();
    }
    prevPath.current = pathname;
  }, [pathname]);
  return null;
}

function Router() {
  const routes = useRoutes([
    { path: '/', element: <Home /> },
    { path: '/age_smoker', element: <AgeSmoker /> },
    { path: '/pdpa', element: <Pdpa /> },
    { path: '/uniquecode', element: <UniqueCode /> },
    { path: '/otp', element: <Otp /> },
    { path: '/smokerprofile', element: <SmokerProfile /> },
    { path: '/devreg', element: <DevReg /> },
    { path: '/switch', element: <Switch /> },
    { path: '/switch-reason', element: <SwitchReason /> },
    { path: '/npd-awareness', element: <NpdAwareness /> },
    { path: '/npd-correct', element: <NpdCorrect /> },
    { path: '/npd-wrong', element: <NpdWrong /> },
    { path: '/tradein', element: <TradeIn /> },
    { path: '/tradeincontact', element: <TradeInContact /> },
    { path: '/tng', element: <Tng /> },
    { path: '/thankyou', element: <ThankYou /> },
    { path: '*', element: <Navigate to="/" replace /> },
  ]);
  return (
    <>
      <ResetClientWhenLeavingTng />
      {routes}
    </>
  );
}

export default Router;
